// Should stay in sync with observationType.mjs
export const OBSERVATION_TYPE = {
  NA: 0,
  ATM_OBSERVER: 1,
  ATL_OBSERVER: 2
};
